const CITIES: Record<string, string[]> = {
	en: [
		"Neon City",
		"Silver Bay",
		"Crimson Falls",
		"Shadow Ridge",
		"Nova Point",
		"Frost Harbor",
		"Iron Valley",
		"Storm Peak",
		"Obsidian Bay",
		"Velvet Coast",
		"Thunder Plains",
		"Echo City",
		"Lunar Heights",
		"Blaze Harbor",
		"Phantom Ridge",
		"Crystal Bay",
		"Vortex City",
		"Solaris",
		"Midnight Port",
		"Aurora Heights",
		"Inferno City",
		"Zenith Bay",
		"Driftwood",
		"Pulse City",
		"Radiant Point",
		"Gravity Falls",
		"Mirage Coast",
		"Cosmic Bay",
		"Hyperion",
		"Taipei X",
	],
	zh: [
		"呆北",
		"辛北",
		"逃園",
		"呆中",
		"呆難",
		"搞雄",
		"雞隆",
		"辛竹",
		"家義",
		"苗力",
		"章化",
		"難投",
		"雲淋",
		"蘋東",
		"疑蘭",
		"滑蓮",
		"呆東",
		"碰湖",
		"金閂",
		"蓮江",
		"辛竹縣",
		"家義縣",
		"蛋水",
		"扳橋",
		"中力",
		"風山",
		"三種",
		"魯洲",
		"永盒",
		"信溢",
	],
};

const MASCOTS: Record<string, string[]> = {
	en: [
		"Phantoms",
		"Neon Riders",
		"Skybreakers",
		"Night Owls",
		"Cyber Wolves",
		"Ghost Drifters",
		"Thunder Cats",
		"Void Walkers",
		"Fire Hawks",
		"Iron Giants",
		"Storm Bringers",
		"Shadow Ninjas",
		"Nova Knights",
		"Blaze Spirits",
		"Frost Reapers",
		"Cosmic Pirates",
		"Laser Sharks",
		"Gravity Smashers",
		"Pixel Warriors",
		"Turbo Foxes",
		"Quantum Kings",
		"Dark Matter",
		"Solar Raiders",
		"Echo Fighters",
		"Plasma Bears",
		"Rocket Lizards",
		"Hyper Monkeys",
		"Steel Panthers",
		"Vortex Dragons",
		"Dream Hackers",
	],
	zh: [
		"閃電鴨",
		"火焰雞",
		"鐵甲熊",
		"忍者貓",
		"暴風鯊",
		"幽靈犬",
		"雷霆虎",
		"飛天豬",
		"爆走猴",
		"宇宙龍",
		"機甲鹿",
		"旋風兔",
		"電音狐",
		"暗影蛇",
		"流星鷹",
		"鋼鐵象",
		"暴走龜",
		"彩虹魚",
		"火箭鼠",
		"巨浪鯨",
		"狂野狼",
		"閃光豹",
		"忍術蛙",
		"極速馬",
		"電光獅",
		"夢幻鹿",
		"銀河犬",
		"暴風龍",
		"街頭猴",
		"未來人",
	],
};

export function generateRandomTeamNames(language: string): [string, string] {
	const lang = language in CITIES ? language : "en";
	const cities = CITIES[lang];
	const mascots = MASCOTS[lang];

	const cityA = Math.floor(Math.random() * cities.length);
	let cityB = Math.floor(Math.random() * (cities.length - 1));
	if (cityB >= cityA) cityB++;

	const mascotA = Math.floor(Math.random() * mascots.length);
	let mascotB = Math.floor(Math.random() * (mascots.length - 1));
	if (mascotB >= mascotA) mascotB++;

	return [
		`${cities[cityA]} ${mascots[mascotA]}`,
		`${cities[cityB]} ${mascots[mascotB]}`,
	];
}
